import css from './class-details.scss';

export const BASE_COL_CONFIG = [
    {
        id: 'student',
        name: 'STUDENT',
        sort: { sortAs: student => student.lastName },
        trans: 'Label - Student'
    },
    {
        id: 'participationPoints',
        name: 'PARTICIPATION POINTS',
        trans: 'Label - ParticipationPoints'
    },
    {
        id: 'liveMathsPoints',
        name: 'LIVE MATHLETICS POINTS',
        trans: 'Label - LiveMathPoints'
    }
];
export const BASE_COL_GROUP = [
    {
        name: '',
        colIds: ['student', 'participationPoints', 'liveMathsPoints'],
        classes: css['first-group']
    }
];
export const BASE_TOTAL_CERTIFICATES_COLGROUP = [
    {
        name: 'TOTAL',
        colIds: ['totalCertificates'],
        classes: css['total-group']
    }
];
export const BASE_TOTAL_CERTIFICATES_COL = [
    {
        id: 'totalCertificates',
        name: 'TOTAL CERTIFICATES',
        trans: 'Label - Certificates'
    }
];
export const NEW_CERT_COL_GROUP = [
    {
        name: 'NEW CERTIFICATES',
        colIds: ['totalNew'],
        trans: 'Label - NewCertificates',
        certType: 'new',
        hasHeaderBtn: true,
        expanded: false
    }
];
export const NEW_CERT_COL_GROUP_EXPANDED = [
    {
        name: 'NEW CERTIFICATES',
        colIds: ['bronze', 'silver', 'gold', 'platinum', 'emerald', 'diamond', 'epic', 'legend'],
        trans: 'Label - NewCertificates',
        certType: 'new',
        hasHeaderBtn: true,
        expanded: true
    }
];
export const NEW_CERT_COL = [
    {
        id: 'totalNew',
        name: 'TOTAL NEW',
        trans: 'Label - TotalNew'
    }
];
export const NEW_CERT_COL_EXPANDED = [
    {
        id: 'bronze',
        name: 'BRONZE',
        trans: 'Label - Bronze',
        case: 'lower'
    },
    {
        id: 'silver',
        name: 'SILVER',
        trans: 'Label - Silver',
        case: 'lower'
    },
    {
        id: 'gold',
        name: 'GOLD',
        trans: 'Label - Gold',
        case: 'lower'
    },
    {
        id: 'platinum',
        name: 'PLATINUM',
        trans: 'Label - Platinum',
        case: 'lower'
    },
    {
        id: 'emerald',
        name: 'EMERALD',
        trans: 'Label - Emerald',
        case: 'lower'
    },
    {
        id: 'diamond',
        name: 'DIAMOND',
        trans: 'Label - Diamond',
        case: 'lower'
    },
    {
        id: 'epic',
        name: 'EPIC',
        trans: 'Label - Epic',
        case: 'lower'
    },
    {
        id: 'legend',
        name: 'Legend',
        trans: 'Label - Legend',
        case: 'lower'
    }

];
export const PAST_CERT_COL_GROUP = [
    {
        name: 'PAST CERTIFICATES',
        colIds: ['totalPast'],
        trans: 'Label - PastCertificates',
        certType: 'past',
        hasHeaderBtn: true,
        expanded: false,
        classes: css['past-group']
    }
];
export const PAST_CERT_COL_GROUP_EXPANDED = [
    {
        name: 'PAST CERTIFICATES',
        colIds: ['bronzePast', 'silverPast', 'goldPast'],
        trans: 'Label - PastCertificates',
        certType: 'past',
        hasHeaderBtn: true,
        expanded: true,
        classes: css['past-group']
    }
];


export const PAST_CERT_COL = [
    {
        id: 'totalPast',
        name: 'TOTAL PAST',
        trans: 'Label - TotalPast'
    }
];
export const PAST_CERT_COL_EXPANDED = [
    {
        id: 'bronzePast',
        name: 'BRONZE',
        trans: 'Label - Bronze',
        case: 'lower'
    },
    {
        id: 'silverPast',
        name: 'SILVER',
        trans: 'Label - Silver',
        case: 'lower'
    },
    {
        id: 'goldPast',
        name: 'GOLD',
        trans: 'Label - Gold',
        case: 'lower'
    }
];

export const NO_STUDENTS_FOUND_LOAD = 'No students available';
export const NO_STUDENTS_FOUND_SEARCH = 'No students found';



// WEBPACK FOOTER //
// ./containers/class-details/class-details-constants.js